// extracted by mini-css-extract-plugin
export default {"frameworkCallOff":"S_dg52SR1Ll2Jzq3GHlA__frameworkCallOff___","callOffCount":"tAXsJCSYYbYSSX1E__sZ__callOffCount___","callOffValue":"w0kprAPWHoAFHbLjwPLR__callOffValue___"};